module.exports = __webpack_public_path__ + "static/img/3.志工服務活動-1.9f21935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/3.志工服務活動-1.jpg
// module id = /Ioh
// module chunks = 100